/**
 * `Ф0` (кабинет ПЗС): кто входит в кабинет и куда попадает после входа.
 *
 * `Л7` (`АРХ-16.10е`): кабинет — это `ПЗС` и `владелец станции`; у обеих ролей
 * одни и те же маршруты. `root` тоже допущен (он видит всё), но его посадочная
 * страница остаётся админской: кабинет — не его рабочее место.
 *
 * Оператор объекта и оператор организации в кабинет не входят: у них свои
 * разделы, и «чужие» места они там не видят.
 */

export const CABINET_ROLES: string[] = ["ПЗС", "владелец станции", "root"];

/** Роли, для которых кабинет — основное место после входа. */
export const CABINET_HOME_ROLES: string[] = ["ПЗС", "владелец станции"];

export const CABINET_LANDING = "/cabinet/stations";

export function isCabinetRole(role?: string | null): boolean {
  return CABINET_HOME_ROLES.includes(String(role));
}

/** Оператор объекта в кабинет не пускается. */
export function canEnterCabinet(role?: string | null): boolean {
  return CABINET_ROLES.includes(String(role));
}
